<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/colchagua/montes-folly')">Montes Folly</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile show-mobile-select"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Valle di Colchagua</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Per quelli di voi a cui piacciono i vini inchiostro, neri e fruttati con un corpo pieno che offrono un ottimo rapporto qualità-prezzo, allora la valle di Colchagua potrebbe essere la regione dei vostri sogni. Situato a metà strada tra le Ande e la catena montuosa costiera, a circa 110 miglia a sud di Santiago, il vino della regione è più famoso della regione stessa. Conosciuta per il suo corposo Carménère (di gran lunga la star dello spettacolo qui) Syrah e Malbec, la regione sostiene i produttori di vino indipendenti ed è sede di alcune delle principali aziende vinicole del paese.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Colchagua-Tal</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Für diejenigen unter Ihnen, die tiefschwarze, fruchtige Weine mit vollem Körper mögen, die viel für Ihr Geld bieten, dann könnte das Colchagua-Tal genau die richtige Region für Sie sein. Die Region liegt auf halbem Weg zwischen den Anden und dem Küstengebirge, etwa 110 Meilen südlich von Santiago. Der Wein der Region ist berühmter als die Region selbst. Die Region ist bekannt für ihren vollmundigen Carménère (hier bei weitem der Star der Show), Syrah und Malbec, setzt sich für unabhängige Winzer ein und beherbergt einige der führenden Weingüter des Landes.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vallée de Colchagua</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pour ceux d'entre vous qui aiment les vins d'encre, noirs et fruités avec un corps plein qui offrent beaucoup pour leur argent, alors la vallée de Colchagua pourrait bien être la région de vos rêves. Situé à mi-chemin entre les Andes et la chaîne de montagnes côtières, à environ 110 miles au sud de Santiago, le vin de la région est plus célèbre que la région elle-même. Connue pour son Carménère corsé (de loin la star du spectacle ici) Syrah et Malbec, la région défend les vignerons indépendants et abrite certains des principaux vignobles du pays.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Colchagua Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        For those of you who like inky, black, fruity wines with a full body that offer a lot of bang for your buck, then the Colchagua valley could just be your dream region. Located halfway between the Andes and Coastal Mountain Range, about 110 miles south of Santiago, the region’s wine is more famous than the region itself. Known for its full-bodied Carménère (by far the star of the show here) Syrah and Malbec, the region champions independent winemakers and is home to some of the country’s leading wineries.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Colchagua",
        data () {
            return {
                select: { report: 'Montes Folly', src: '/wine-guide/chile/colchagua/montes-folly' },
                items: [
                    { report: 'Montes Folly', src: '/wine-guide/chile/colchagua/montes-folly' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Colchagua Valley fine wine | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Experience the rich flavors and diverse terroirs of the Colchagua wine region in Chile. Known for producing premium red wines, including Carmenere, Syrah, and Cabernet Sauvignon, Colchagua offers a unique winemaking experience unlike any other. Explore the stunning vineyards and taste the remarkable wines that embody the essence of Chile\'s winemaking tradition with a visit to the Colchagua wine region.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
